export default __webpack_public_path__ + "static/media/m_wdt_c_1.ca854bb8.mp3";